/*
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 * ANATOMIA SYGNAŁU — jedna lista, dwa miejsca użycia
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *
 * Kolejność i nazwy części sygnału były dotąd prywatne dla `KartaSygnalu`. Makieta pokazuje je
 * jeszcze raz, jako osobną kartę wyjaśniającą („Jak powstaje insight"), i to jest sensowne:
 * karta sygnału EGZEKWUJE anatomię, ale nigdy nie mówi czytelnikowi, po co ona jest.
 *
 * Wyciągamy więc listę tutaj, zamiast wpisywać ją drugi raz w ekranie. Dwie listy tych samych
 * czterech kroków rozjechałyby się przy pierwszej zmianie nazwy i produkt tłumaczyłby budowę,
 * której już nie ma — a to gorsze niż brak wyjaśnienia.
 */

export const ANATOMIA = ['CO_SIE_STALO', 'DLACZEGO_WAZNE', 'DOWOD', 'CO_SPRAWDZIC'] as const;

export type Krok = (typeof ANATOMIA)[number];

export const NAGLOWEK_KROKU: Record<Krok, string> = {
  CO_SIE_STALO: 'Co się stało',
  DLACZEGO_WAZNE: 'Dlaczego to ważne',
  // Łańcuch „na czym to stoi" jest w kontrakcie testów E2E — zostaje dosłownie.
  DOWOD: 'Dowód — na czym to stoi',
  CO_SPRAWDZIC: 'Co sprawdzić',
};

/**
 * Po co jest każdy krok. Treść przeniesiona z makiety (`ANATOMIA` w js/screens/insighty.js),
 * z jedną zmianą: opis kroku „Co sprawdzić" mówi wprost, że to są PYTANIA, nie przyczyny —
 * bo na tym ekranie to jest najczęstsze nieporozumienie, a nie szczegół stylistyczny.
 */
export const OPIS_KROKU: Record<Krok, string> = {
  CO_SIE_STALO: 'Sama obserwacja: wielkość, okno, kierunek. Bez ocen i bez przymiotników.',
  DLACZEGO_WAZNE: 'Co ta zmiana robi z decyzją. Bez tego sygnał jest ciekawostką.',
  DOWOD: 'Liczby, z których reguła powstała — razem z podstawą liczenia. Do sprawdzenia i do podważenia.',
  CO_SPRAWDZIC: 'Pytania do ludzi i systemów. NIE przyczyny — reguła ich nie zna i nie zgaduje.',
};
